/**
 *   Generated file. Do not edit
 */

export class ResultCode {
  /**
   * The request was successful
   * hex: 0x0 / decimal: 0
   */
  public static OK = 0x0;

  /**
   * Create request was successful
   * hex: 0x41 / decimal: 65
   */
  public static CREATED = 0x41;

  /**
   * Delete request was successful
   * hex: 0x42 / decimal: 66
   */
  public static DELETED = 0x42;

  /**
   * Update request was successful
   * hex: 0x44 / decimal: 68
   */
  public static CHANGED = 0x44;

  /**
   * The server has fulfilled the request and sent a response
   * hex: 0x45 / decimal: 69
   */
  public static CONTENT = 0x45;

  /**
   * The server is busy
   * hex: 0x46 / decimal: 70
   */
  public static BUSY = 0x46;

  /**
   * Bad request. Meaning device cannot understand your request.
   * hex: 0x80 / decimal: 128
   */
  public static BAD_REQUEST = 0x80;

  /**
   * Current user is not authorized to access this ressource
   * hex: 0x81 / decimal: 129
   */
  public static UNAUTHORIZED = 0x81;

  /**
   * The server has not found anything matching the Request
   * hex: 0x84 / decimal: 132
   */
  public static NOT_FOUND = 0x84;

  /**
   * Current user is not authorized to access this ressource
   * hex: 0x85 / decimal: 133
   */
  public static METHOD_NOT_ALLOWED = 0x85;

  /**
   * Given parameters are not acceptable
   * hex: 0x86 / decimal: 134
   */
  public static NOT_ACCEPTABLE = 0x86;

  /**
   * Given resource is not available with the current TAP configuration.
   * hex: 0x87 / decimal: 135
   */
  public static RESOURCE_LOCKED = 0x87;

  /**
   * Internal server error
   * hex: 0xa0 / decimal: 160
   */
  public static INTERNAL_SERVER_ERROR = 0xa0;

  /**
   * This resource has not been implemented yet
   * hex: 0xa1 / decimal: 161
   */
  public static NOT_IMPLEMENTED = 0xa1;

  /**
   * Service is currently unavailable. Try again later.
   * hex: 0xa3 / decimal: 163
   */
  public static SERVICE_UNAVAILABLE = 0xa3;

  /**
   * Writing non volatible memory failed
   * hex: 0xa4 / decimal: 164
   */
  public static NVM_ERROR = 0xa4;

  /**
   * Tap was not able to connect to the target
   * hex: 0xa5 / decimal: 165
   */
  public static UNABLE_TO_CONNECT_TO_TARGET = 0xa5;

  /**
   * Target power failure
   * hex: 0xa6 / decimal: 166
   */
  public static TARGET_POWER_FAILURE = 0xa6;

  /**
   * Non volatile memory is full
   * hex: 0xa7 / decimal: 167
   */
  public static NVM_FULL = 0xa7;

  /**
   * It means we can't access this resource because someone is already connected to this device and he has the priority over us.
   * hex: 0xa8 / decimal: 168
   */
  public static DEVICE_UNAVAILABLE = 0xa8;

  /**
   * Response is bigger than you current protocol limit
   * hex: 0xa9 / decimal: 169
   */
  public static RESPONSE_TOO_LARGE = 0xa9;

  /**
   * Target protocol error
   * hex: 0xb0 / decimal: 176
   */
  public static TARGET_PROTOCOL_ERROR = 0xb0;

  /**
   * Target protocol is busy
   * hex: 0xb1 / decimal: 177
   */
  public static TARGET_PROTOCOL_BUSY = 0xb1;

  /**
   * Target protocol error
   * hex: 0xb2 / decimal: 178
   */
  public static TARGET_PROTOCOL_REAL = 0xb2;

  /**
   * Target protocol parameters are not valid
   * hex: 0xb3 / decimal: 179
   */
  public static TARGET_PROTOCOL_WRONG_PARAM = 0xb3;

  /**
   * Target protocol is forbidden
   * hex: 0xb4 / decimal: 180
   */
  public static TARGET_PROTOCOL_FORBIDDEN = 0xb4;

  /**
   * Target protocol data are not the one expected. For example a CRC error.
   * hex: 0xb5 / decimal: 181
   */
  public static TARGET_PROTOCOL_DATA = 0xb5;

  /**
   * Target protocol communication error
   * hex: 0xb6 / decimal: 182
   */
  public static TARGET_PROTOCOL_COM = 0xb6;

  /**
   * Target protocol lost communication
   * hex: 0xb7 / decimal: 183
   */
  public static TARGET_PROTOCOL_LOST_COM = 0xb7;

  /**
   * Target protocol invalid parameter
   * hex: 0xb8 / decimal: 184
   */
  public static TARGET_PROTOCOL_PARAM = 0xb8;

  /**
   * Internal error with target communication
   * hex: 0xb9 / decimal: 185
   */
  public static TARGET_PROTOCOL_INT = 0xb9;

  /**
   * Operation aborted because one of the command did not return the expected result code.
   * hex: 0xba / decimal: 186
   */
  public static TARGET_PROTOCOL_ABORT = 0xba;

  /**
   * Target protocol is not implemented
   * hex: 0xbb / decimal: 187
   */
  public static TARGET_PROTOCOL_NOT_IMPLEMENTED = 0xbb;
}
